import jwt from "jsonwebtoken";

export const isValidToken = (token: string): boolean => {
  try {
    const decoded = jwt.decode(token) as { userId: number };
    return !!decoded.userId;
  } catch (error) {
    return false;
  }
};
